/**
 * Utility functions for app redirection and deep linking
 */

/**
 * Attempt to redirect to the native app, with fallback to App Store or web
 */
export const redirectToApp = (invitationToken: string) => {
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  const isAndroid = /Android/.test(navigator.userAgent);
  
  // Deep link URL for the app
  const deepLinkUrl = `clan://invite?token=${invitationToken}`;
  
  if (isIOS) {
    // Try to open the app, fallback to App Store
    window.location.href = deepLinkUrl;
    
    // Fallback after a short delay if app doesn't open
    setTimeout(() => {
      // Redirect to App Store
      window.location.href = `https://apps.apple.com/app/id6752715950`;
    }, 2500);
    
  } else if (isAndroid) {
    // Try to open the app, fallback to Play Store
    window.location.href = deepLinkUrl;
    
    setTimeout(() => {
      // TODO: Replace with actual Play Store URL when available
      window.location.href = '/dashboard';
    }, 2500);
    
  } else {
    // Desktop or other - redirect to dashboard
    window.location.href = '/dashboard';
  }
};

/**
 * Check if we're likely running inside the mobile app
 */
export const isRunningInApp = (): boolean => {
  // Check if we're in a Capacitor app
  return !!(window as any).Capacitor;
};
